import React, { useState } from 'react';
import { useAuth } from 'contexts/AuthContext';
import { Button } from 'components';
import './AuthForm.scss';

export default function AuthForm({ onSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const res = await login({ email, password });
    setLoading(false);
    if (res.ok) {
      onSuccess && onSuccess();
    } else {
      setError(res.error || 'Login failed');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: 8 }}>
        <label className="auth-label">Email</label>
        <div className="auth-field">
          <input className="auth-input" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required placeholder="you@example.com" />
        </div>
      </div>
      <div style={{ marginBottom: 8 }}>
        <label className="auth-label">Пароль</label>
        <div className="auth-field">
          <input className="auth-input" value={password} onChange={(e) => setPassword(e.target.value)} type={showPassword ? 'text' : 'password'} required placeholder="********" />
          <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>{showPassword ? '🙈' : '👁️'}</button>
        </div>
      </div>
          {error && (
            <div className="auth-error">
              {typeof error === 'string' && error}
              {error && typeof error === 'object' && (
                // Prefer `detail` (DRF style), then try common keys or first message
                (error.detail && String(error.detail)) ||
                (error.message && String(error.message)) ||
                // If object contains arrays or nested messages, try to extract first one
                (Object.values(error).flat ? String(Object.values(error).flat()[0]) : null) ||
                // Fallback to JSON stringify for debug
                JSON.stringify(error)
              )}
            </div>
          )}
      <div className="auth-actions">
        <Button className="auth__btn" type="submit" style={{ width: '100%' }} disabled={loading}>{loading ? 'Вход...' : 'Войти'}</Button>
        <Button className="google-btn" type="button" onClick={() => {
          const redirectUri = encodeURIComponent('https://ncore.kg/');
          const scope = encodeURIComponent('openid email profile');
          const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${process.env.REACT_APP_GOOGLE_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=token&scope=${scope}&prompt=select_account`;
          window.location.href = authUrl;
        }}>
          <span className="google-logo" dangerouslySetInnerHTML={{ __html: '<svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" width="18" height="18"><g fill="none" fill-rule="evenodd"><path d="M9 3.48c1.69 0 2.88.73 3.54 1.34l2.6-2.5C13.87.9 11.66 0 9 0 5.48 0 2.44 1.93 1 4.77l2.99 2.33C4.9 5.03 6.74 3.48 9 3.48z" fill="#EA4335"/><path d="M17.64 9.2c0-.64-.06-1.12-.18-1.61H9v3.04h4.84c-.2 1.08-.82 2.08-1.74 2.72l2.8 2.17c1.63-1.5 2.54-3.72 2.54-6.32z" fill="#4285F4"/><path d="M3.29 10.39A5.4 5.4 0 0 1 3 9c0-.62.11-1.22.29-1.79L.3 4.87A9 9 0 0 0 0 9c0 1.45.33 2.83.9 4.06l2.39-2.67z" fill="#FBBC05"/><path d="M9 18c2.43 0 4.47-.8 5.96-2.17l-2.8-2.17C11.6 13.7 10.4 14.3 9 14.3c-2.26 0-4.1-1.55-4.73-3.64L1.28 12.98C2.72 15.81 5.76 18 9 18z" fill="#34A853"/></g></svg>' }} />
          Google
        </Button>
         <Button className="telegram-btn" type="button"  >
          <span className="tg-logo" dangerouslySetInnerHTML={{ __html: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" width="18" height="18"><g fill="none" fill-rule="evenodd"><circle cx="120" cy="120" r="120" fill="#2AABEE"/><path d="M52.4 121.4c40.4-16 66.5-26.4 79.3-31.2 9.1-3.4 17 2 13 12-2.4 5.9-18 39.9-28 61.9-3.5 8-6 14.6-10 18-3.5 3-8.5 4.5-14 3.5-9-1.6-21.5-7.2-33-13.5-8.8-5.2-12.5-9.6-13.5-13.5-1.9-6.9 1.4-15.3 11.2-18.9z" fill="#FFF"/></g></svg>' }} />
          Telegram
        </Button>
      </div>
      <div className="auth-footer">Вход производится через email и пароль или Google аккаунт</div>
    </form>
  );
}
